export default __webpack_public_path__ + "static/media/snowflake-instructions-2.222ebbd7.png";